import type { ReactNode } from "react";
import { Link, usePathname, useUrlState } from "@/app/navigation";
export function CompanyLink({ id, children }: { id: string; children: ReactNode }) {
  const { params, update } = useUrlState();
  const path = usePathname();
  const changes = {
    companyId: id,
    companyTab: null,
    companyPage: null,
    personId: null,
    personTab: null,
    activityId: null,
    runId: null,
  };
  const next = new URLSearchParams(params);
  for (const [key, value] of Object.entries(changes)) {
    if (value === null) next.delete(key);
    else next.set(key, value);
  }
  return (
    <Link
      href={`${path}?${next}`}
      data-company-id={id}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
          return;
        event.preventDefault();
        update(changes);
      }}
    >
      {children}
    </Link>
  );
}
